import { ArrowLeft } from "lucide-react";

export default function BackButton({
  onClick,
  label = "",
  className = "",
}) {
  const classes = [
    "back-button",
    !label && "back-button--icon-only",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      aria-label={label || "Back"}
    >
      <ArrowLeft
        width={24}
        height={20}
        strokeWidth={2}
      />
      {label && <span>{label}</span>}
    </button>
  );
}